import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-ring-miles-field',
  templateUrl: './ring-miles-field.component.html',
  styleUrls: ['./ring-miles-field.component.scss']
})
export class RingMilesFieldComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string = 'ringMiles';
  @Input()
  placeholder: string = 'Miles';
  @Input()
  maxRadius = 10;

  @ViewChild('radiusInput')
  radiusInput: ElementRef<HTMLInputElement>;

  constructor() {
  }
    onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = Number(input.value);
    const control = this.form.get(this.controlName);
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    if (value > 10) {
      input.value = '10';
      control.setValue(10);
      control.setErrors({ ...(control.errors || {}), max: true });
    }else {
      if (control.hasError('max')) {
        const newErrors = { ...control.errors };
        delete newErrors['max'];
        control.setErrors(Object.keys(newErrors).length ? newErrors : null);
      }
    }

    if (value < 1) {
      input.value = '1';
      control.setValue('');
      control.setErrors({ ...(control.errors || {}), min: true });
    } else {
      if (control.hasError('min')) {
        const newErrors = { ...control.errors };
        delete newErrors['min'];
        control.setErrors(Object.keys(newErrors).length ? newErrors : null);
      }
    }
  }
}
